/**
 * @generated SignedSource<<c325ec8f2b83670decc2cd17b3f06544>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeWorkStatus = "NOT_WORKING" | "WORKING";
import { FragmentRefs } from "relay-runtime";
export type TeamHeaderRoles_team$data = {
  readonly id: string;
  readonly roles: ReadonlyArray<{
    readonly employeeCount: number;
    readonly employees: ReadonlyArray<{
      readonly id: string;
      readonly isLinkedToViewer: boolean;
      readonly workStatus: EmployeeWorkStatus;
      readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
    }>;
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "TeamHeaderRoles_team";
};
export type TeamHeaderRoles_team$key = {
  readonly " $data"?: TeamHeaderRoles_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderRoles_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamHeaderRoles_team",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeRole",
      "kind": "LinkedField",
      "name": "roles",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employeeCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employees",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLinkedToViewer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "workStatus",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Avatar_employee"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "4edaed6eb7c68da4b105905445ab07cf";

export default node;
